export const productCategories = [
	{
		id: 'generators',
		parentCategoryId: null,
		menuName: 'Generators',
		title: 'SmartSizingTM',
		subtitle: null,
		shortDescription: 'Please enter shower size and material in order to select the correct generator model for your spa.',
		longDescription: null,
        // techSpecsLink: null,
        image: null,
        renderMode: 'expanded',
        customRenderer: 'generator-configurator-cmp',
        isVisible: true,
        allowInCartMultipleProds: false,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 1,
        zIndex: 1
	},
	{
		id: 'steam-shower-controls',
		parentCategoryId: null,
		menuName: 'Controls',
		title: 'Steam Shower Controls',
		subtitle: 'Select the right Control Series for you.',
		shortDescription: null,
		longDescription: null,
        // techSpecsLink: null,
        image: null,
        renderMode: 'expanded',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 2,
        zIndex: 2
	},
    {
        id: 'isteamx-touch-screen-controls',
        parentCategoryId: 'steam-shower-controls',
        menuName: 'iSteamX Touch Screen Control',
        title: 'iSteamX Touch Screen Control',
        subtitle: 'MrSteam’s complete control packages simplify your choices and save you money! You can select a steam control and options à la carte, but our Control Packages make it so simple.',
        shortDescription: null,
		longDescription: 'If swipe screen functionality (like a smart phone), is what you want along with the ability to add music, chroma and aroma therapies, then the iSteam controls is for you',
        // techSpecsLink: null,
        image: 'ISTEAMXBKPC.jpg',
        renderMode: 'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 3,
        zIndex: 3
    },
    {
        id: 'airtempo-wireless-controls',
        parentCategoryId: 'steam-shower-controls',
        menuName: 'AirTempo Wireless Control',
        title: 'AirTempo Wireless Control',
        subtitle: 'MrSteam’s complete control packages simplify your choices and save you money! You can select a steam control and options à la carte, but our Control Packages make it so simple.',
        shortDescription: null,
		longDescription: 'If wireless, surface mount (on any surface, even glass), easy installation and LCD display suits your home spa needs, then AirTempo is the right choice',
        // techSpecsLink: null,
        image: 'AirTempo-Black.jpg',
        renderMode: 'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 3,
        zIndex: 3
    },
    {
        //id: 'itempo-touch-pad-controls',
        id: 'itempo-plus-controls',
        parentCategoryId: 'steam-shower-controls',
        menuName: 'iTempo Plus',
        title: 'iTempo Plus Control',
        subtitle: 'MrSteam’s complete control packages simplify your choices and save you money! You can select a steam control and options à la carte, but our Control Packages make it so simple.',
        shortDescription: null,
		longDescription: 'If you want to activate your steam shower with the press of button and a wide variety of finishes, iTempo is for you',
        // techSpecsLink: null,
        image: 'iTempo-Square.jpg',
        renderMode: 'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 3,
        zIndex: 3
    },

    {
        //id: 'itempo-touch-pad-controls',
        id: 'itempo-controls',
        parentCategoryId: 'steam-shower-controls',
        menuName: 'iTempo',
        title: 'iTempo Control',
        subtitle: 'MrSteam’s complete control packages simplify your choices and save you money! You can select a steam control and options à la carte, but our Control Packages make it so simple.',
        shortDescription: null,
		longDescription: 'If you want to activate your steam shower with the press of button and a wide variety of finishes, iTempo is for you',
        // techSpecsLink: null,
        image: 'itempopc.jpg',
        renderMode: 'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 4,
        zIndex: 4
    },
    // {
    //     id: 'individual-controls',
    //     parentCategoryId: 'steam-shower-controls',
    //     menuName: 'Individual controls',
    //     title: 'Individual controls',
    //     subtitle: 'Select Control Style (required for steam shower operation)',
    //     shortDescription: null,
		// longDescription: null,
    //     // techSpecsLink: null,
    //     image: null,
    //     renderMode: 'expanded',
    //     customRenderer: null,
    //     isVisible: true,
    //     allowInCartMultipleProds: false,
    //     // allowInCartMultipleSubCatProds: true,
    //     sortOrder: 3,
    //     zIndex: 3
    // },
    // {
    //     id: 'control-packages',
    //     parentCategoryId: 'steam-shower-controls',
    //     menuName: 'Control Packages',
    //     title: 'Control Packages',
    //     subtitle: 'Required for steam shower operation',
    //     shortDescription: 'The iDream and Butler Packages include everything you require to ensure a great steambath along with a 12% savings.',
		// longDescription: null,
    //     // techSpecsLink: null,
    //     image: null,
    //     renderMode: 'expanded',
    //     customRenderer: null,
    //     isVisible: true,
    //     allowInCartMultipleProds: false,
    //     // allowInCartMultipleSubCatProds: true,
    //     sortOrder: 5,
    //     zIndex: 5
    // },
    {
        id: 'controls-accessories',
        parentCategoryId: 'steam-shower-controls',
        menuName: 'Control Accessories',
        title: 'Control Accessories',
        subtitle: 'Steam Bath Accessories à la Carte',
        shortDescription: null,
		longDescription: null,
        // techSpecsLink: null,
        image: null, 
        renderMode: 'expanded',
        customRenderer: null,
        isVisible: false, // false
        allowInCartMultipleProds: true,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 4,
        zIndex: 4
    },
    {
        id: 'controls-accessories-2',
        parentCategoryId: 'steam-shower-controls',
        menuName: 'Control Accessories',
        title: 'Control Accessories',
        subtitle: 'Steam Bath Accessories à la Carte',
        shortDescription: null,
		longDescription: null,
        // techSpecsLink: null,
        image: null, 
        renderMode: 'expanded',
        customRenderer: null,
        isVisible: false, // false
        allowInCartMultipleProds: true,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 5,
        zIndex: 5
    },
	{
		id: 'options-and-accessories',
		parentCategoryId: null,
		menuName: 'Accessories',
		title: null, // 'Options & Accessories',
		subtitle: null, // 'Select spa Therapies, accessories or bath & body therapies',
		shortDescription: null,
		longDescription: null,
        // techSpecsLink: null,
        image: null,
        renderMode: 'expanded',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: true,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 6,
        zIndex: 6
	},
    {
        id: 'spa-therapies',
        parentCategoryId: 'options-and-accessories',
        menuName: 'Spa Therapies',
        title: 'Spa Therapies',
        subtitle: 'Individual Spa Upgrades',
        shortDescription: null,
		longDescription: null,
        // techSpecsLink: null,
        image: null,
        renderMode: 'expanded', //'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: true,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 7,
        zIndex: 7
    },
    {
        id: 'accessories',
        parentCategoryId: 'options-and-accessories',
        menuName: 'Accessories',
        title: 'Accessories',
        subtitle: 'Select accessories',
        shortDescription: 'Enhance your spa like shower by adding customized light fixtures, shower seats and essential chakra oils.',
		longDescription: null,
        // techSpecsLink: null,
        image: null,
        renderMode: 'expanded', //'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: true,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 8,
        zIndex: 8
    },
    /*{
        id: 'bath-and-body-therapies',
        parentCategoryId: 'options-and-accessories',
        menuName: 'Bath & Body Therapies',
        title: 'Bath & Body Therapies',
        subtitle: 'Select bath & body therapies',
        shortDescription: null,
		longDescription: null,
        // techSpecsLink: null,
        image: null,
        renderMode: 'expanded', //'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: true,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 9,
        zIndex: 9
    },*/
    {
        id: 'towel-warmers',
        parentCategoryId: null,
        menuName: 'Towel Warmers',
        title: 'Towel Warmers',
        subtitle: 'Select Towel Warmer Series',
        shortDescription: null,
		longDescription: null,
        // techSpecsLink: null,
        image: null,
        renderMode: 'expanded',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: true,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 10,
        zIndex: 10
    },
    {
        id: 'towel-warmers-200',
        parentCategoryId: 'towel-warmers',
        menuName: 'Broadway',
        title: 'Broadway',
        subtitle: 'Series 200 Electric Heated Towel Warmers',
        shortDescription: 'Broadway Collection is unique and affordable, combining beautiful aesthetic curves with built in aromatherapy oil well and innovative accessories to enhance your spa experience',
		longDescription: 'Broadway Collection is unique and affordable, combining beautiful aesthetic curves with built in aromatherapy oil well and innovative accessories to enhance your spa experience',
        // techSpecsLink: "http://prodrep.mrsteam.com/DocumentResources/41b762fb-cdbf-49bf-9484-665136060749.pdf",
        image: "Towel-Warmers-200.jpg",
        renderMode: 'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 11,
        zIndex: 11
    },
    {
        id: 'towel-warmers-300',
        parentCategoryId: 'towel-warmers',
        menuName: 'Metro',
        title: 'Metro',
        subtitle: 'Stainless Steel Series 300 Towel Warmers',
        shortDescription: 'Metro Collection offers a minimalistic design in Stainless Steel Finish with Aromathearpy Oil Well',
		longDescription: 'Metro Collection offers a minimalistic design in Stainless Steel Finish with Aromathearpy Oil Well',
        // techSpecsLink: "http://prodrep.mrsteam.com/DocumentResources/0e188f2e-9f5f-4320-a410-95599c4d0f7b.pdf",
        image: "Towel-Warmers-300.jpg",
        renderMode: 'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 12,
        zIndex: 12
    },
    {
        id: 'towel-warmers-800',
        parentCategoryId: 'towel-warmers',
        menuName: 'Tribeca',
        title: 'Tribeca',
        subtitle: '800 series towel warmers',
        shortDescription: 'This towel warmer collection is properly named after the very hip and trendy art inspired streets of Tribeca NYC. This inspired collection will catch the eye, warm the heart, soothe the body, and leave you in a warm embrace.',
		longDescription: 'This towel warmer collection is properly named after the very hip and trendy art inspired streets of Tribeca NYC. This inspired collection will catch the eye, warm the heart, soothe the body, and leave you in a warm embrace.',
       // techSpecsLink: "https://pim.mrsteam.com/Resources/Entities/MRSTEAM/Documents/58eb8561-b0e5-4675-828d-bb01d74e943a.pdf",
        image: "Towel-Warmers-800.jpg",
        renderMode: 'compact',
        customRenderer: null,
        isVisible: true,
        allowInCartMultipleProds: false,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 13,
        zIndex: 13
    },
    {
        id: 'towel-warmers-500',
        parentCategoryId: 'towel-warmers',
        menuName: 'Lexington',
        title: 'Lexington',
        subtitle: '500-600 series towel warmers',
        shortDescription: 'Lexington Collection Wall Mounted Electric Towel Warmer with Digital Timer in Stainless Steel Polished and Brushed Stainless Steel ',
		longDescription: 'Lexington Collection Wall Mounted Electric Towel Warmer with Digital Timer in Stainless Steel Polished and Brushed Stainless Steel  ',
        // techSpecsLink: "http://prodrep.mrsteam.com/DocumentResources/05e9cb59-4fdd-4a79-bd48-235cf4b85031.pdf",
        image: "WX41.jpg",
        renderMode: 'compact',
        customRenderer: null,
        isVisible: false,
        allowInCartMultipleProds: false,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 14,
        zIndex: 14
    },
    {
        id: 'towel-warmers-accessories',
        parentCategoryId: 'towel-warmers',
        menuName: 'Towel Warmers Accessories',
        title: 'Towel Warmers Accessories',
        subtitle: 'Select towel Warmers Accessories',
		longDescription: null,
        shortDescription: null,
        // techSpecsLink: null,
        image: null,
        renderMode: 'expanded',
        customRenderer: null,
        isVisible: false, // false
        allowInCartMultipleProds: true,
        // allowInCartMultipleSubCatProds: true,
        sortOrder: 14,
        zIndex: 14
    }
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/data/product-categories.ts